module.exports = __webpack_public_path__ + "img/background060.1a5418e5.jpg";